/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Create_Set_LabelInputs */

const en_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create new tag set`)
};

const fr_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer un nouvel ensemble de tags`)
};

const de_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Tag-Set erstellen`)
};

const it_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un nuovo set di tag`)
};

const ru_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать новый набор тегов`)
};

const es_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear nuevo conjunto de etiquetas`)
};

const zh_cn2_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建新的标签集`)
};

const ja_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいタグセットを作成する`)
};

const hi_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया टैग सेट बनाएं`)
};

const pt_pt2_tags_manager_create_set_label = /** @type {(inputs: Tags_Manager_Create_Set_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar novo conjunto de etiquetas`)
};

/**
* | output |
* | --- |
* | "Create new tag set" |
*
* @param {Tags_Manager_Create_Set_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_create_set_label = /** @type {((inputs?: Tags_Manager_Create_Set_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Create_Set_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_create_set_label(inputs)
	if (locale === "de") return de_tags_manager_create_set_label(inputs)
	if (locale === "it") return it_tags_manager_create_set_label(inputs)
	if (locale === "ru") return ru_tags_manager_create_set_label(inputs)
	if (locale === "es") return es_tags_manager_create_set_label(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_create_set_label(inputs)
	if (locale === "ja") return ja_tags_manager_create_set_label(inputs)
	if (locale === "hi") return hi_tags_manager_create_set_label(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_create_set_label(inputs)
	return en_tags_manager_create_set_label(inputs)
});